// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUYERS_NO_RESULTS = "Moment\u00e1lne nem\u00e1\u0161 \u017eiadnych z\u00e1ujemcov.";
export const BZ2_MESSAGES_FOR_PRODUCT = "Spr\u00e1vy k tomuto inzer\u00e1tu";
export const BZ2_REMOVED_BUYERS = "Odstr\u00e1nen\u00ed z\u00e1ujemcovia";
